var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.2V10.8C4.5 10.9591 4.56321 11.1117 4.67574 11.2243C4.78826 11.3368 4.94087 11.4 5.1 11.4H9.9C10.0591 11.4 10.2117 11.3368 10.3243 11.2243C10.4368 11.1117 10.5 10.9591 10.5 10.8V10.2C10.5 9.72261 10.3104 9.26477 9.97279 8.92721C9.63523 8.58964 9.17739 8.4 8.7 8.4H6.3C5.82261 8.4 5.36477 8.58964 5.02721 8.92721C4.68964 9.26477 4.5 9.72261 4.5 10.2ZM9.3 4.8C9.3 5.27739 9.11036 5.73523 8.77279 6.07279C8.43523 6.41036 7.97739 6.6 7.5 6.6C7.02261 6.6 6.56477 6.41036 6.22721 6.07279C5.88964 5.73523 5.7 5.27739 5.7 4.8C5.7 4.32261 5.88964 3.86477 6.22721 3.52721C6.56477 3.18964 7.02261 3 7.5 3C7.97739 3 8.43523 3.18964 8.77279 3.52721C9.11036 3.86477 9.3 4.32261 9.3 4.8Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.63a8191aa1ecec71791983887c2342d3.svg";
export { ForwardRef as ReactComponent };